import CustomHeader from "@Components/CustomHeader/CustomHeader"
import React from "react"
import { ScrollView, Text, TouchableOpacity, View } from "react-native"
import styles from "./styles"

const CustomScrollableContentWithBackHeader = (props) => {
    const { children } = props

    return (
        <View style={styles.container}>
            <ScrollView  keyboardShouldPersistTaps={"handled"}  contentContainerStyle={{ paddingBottom: 150 }} showsVerticalScrollIndicator={false}>
                <View style={styles.content}>{children}</View>
            </ScrollView>
        </View>
    )
}

export default CustomScrollableContentWithBackHeader
